import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CustomToastrService {
  private readonly toastr = inject(ToastrService);

  showSuccess(message: string) {
    this.toastr.success(message, '', { timeOut: 5000 });
  }

  showError(message: string) {
    this.toastr.error(message, '', { timeOut: 5000 });
  }

  showInfo(message: string) {
    this.toastr.info(message, '', { timeOut: 5000 });
  }
}
